import { Alert, Typography } from '@mui/material';

export default function NotFound() {
  return (
    <Alert severity="warning">
      <Typography>Page not found.</Typography>
    </Alert>
  );
}
